<template>
  <div>
    <Header></Header>

    <div id="aitutor">
      <div class="banner ai_tutor">
        <p class="only_pc">
          기술력과 학습 컨텐츠 모두 인정받은!<br />
          <span>국내유일 대화형 AI 회화 학습</span> 플랫폼
        </p>
        <p class="only_m">
          기술력과 학습 컨텐츠 모두 인정받은!
          <strong><span>국내유일 대화형 AI 회화 학습</span> 플랫폼</strong>
        </p>
        <h2>
          CARROT
          <img
            src="@/assets/img/ai_title.png"
            alt="AI 튜터!"
            class="only_pc inherit"
          /><img
            src="@/assets/img/m/ai_title.png"
            alt="AI 튜터!"
            class="only_m"
          />
        </h2>

        <a
          href="https://www.imooc.co.kr/link/601b85061855b27074"
          target="_blank"
          class="link_more"
          >소개 영상보기</a
        >
      </div>

      <div class="ai_step">
        <h2>
          <span>400여 개의 상황별 시나리오의</span>
          <strong>5단계 학습법</strong>을 통한<br />
          실전상황 경험을 학습으로 전이
        </h2>

        <div class="step_box only_pc">
          <ul class="label_list">
            <li class="point"><span>경험</span></li>
            <li><span>학습</span></li>
            <li><span>훈련</span></li>
            <li class="last"><span>습득</span></li>
          </ul>

          <ul class="step_list">
            <li>
              <span>STEP 01</span>
              <img src="@/assets/img/step1.png" class="inherit" alt="STEP01" />
              <div class="desc">
                <h3>미션 추천 및 수행</h3>
                <p>
                  학습자에게 적절한 미션 추천,<br />다양한 상황 별 대화 연습
                </p>
              </div>
            </li>
            <li class="point">
              <span>STEP 02</span>
              <img src="@/assets/img/step2.png" class="inherit" alt="STEP02" />
              <div class="desc">
                <h3>Dialogue Review</h3>
                <p>
                  나의 답변과 원어민 답변을 비교하여,<br />스스로 틀린 부분 인지
                  후 교정
                </p>
              </div>
            </li>
            <li>
              <span>STEP 03</span>
              <img src="@/assets/img/step3.png" class="inherit" alt="STEP03" />
              <div class="desc">
                <h3>Key Expression</h3>
                <p>미션 속 주요 표현 학습 및<br />다양한 패턴 연습</p>
              </div>
            </li>
            <li>
              <span>STEP 04</span>
              <img src="@/assets/img/step4.png" class="inherit" alt="STEP04" />
              <div class="desc">
                <h3>Drill Practice</h3>
                <p>
                  미션을 대화 별로 복습하고<br />각 질문에 대해 모법답안을 확인
                </p>
              </div>
            </li>
            <li>
              <span>STEP 05</span>
              <img src="@/assets/img/step5.png" class="inherit" alt="STEP05" />
              <div class="desc">
                <h3>Final Review</h3>
                <p>오늘의 미션 상황을 다시 한번<br />대화해보고 습득</p>
              </div>
            </li>
          </ul>
        </div>
        <div class="step_box only_m">
          <img src="@/assets/img/m/step_box.png" class="inherit" alt="" />
        </div>
      </div>

      <div class="ai_about">
        <h2>1,000대 기업이 인정한 <span>컨텐츠와 학습효과</span></h2>
        <p class="only_pc">
          LG, 롯데, 한국전력공사 등 주요기업 20개사 임직원 대상<br />1년간
          AI튜터 학습 후, AI와 사람과의 영어 학습에 대한 효과를 검증한 결과,
        </p>
        <p class="only_m">
          LG, 롯데, 한국전력공사 등 주요기업 20개사<br />임직원 대상 1년간
          AI튜터 학습 후,<br />AI와 사람과의 영어 학습에 대한 효과를 검증한
          결과,
        </p>

        <div class="bubble_wrap">
          <ul class="bubble_list clearfix">
            <li class="bubble1">1. 기존 학습방법 대비 좋은가?</li>
            <li class="bubble2">2. 회화 실력이 향상됐나?</li>
            <li class="bubble3">3. AI의 실력은 뛰어난가?</li>
          </ul>

          <h3>항목에서 <strong>94%이상 만족</strong>하는 것으로 나타났다.</h3>
          <img
            src="@/assets/img/graph.png"
            alt="그래프"
            class="only_pc inherit"
          />
          <img
            src="@/assets/img/m/graph.png"
            alt="그래프"
            class="only_m inherit"
          />
        </div>
      </div>

      <div class="ai_keyword">
        <h2><span>캐럿 AI튜터</span> 이런게 달라요!</h2>

        <dl class="ai_point1">
          <dt>
            <span class="label">Point 01</span>
            CLT 기반 실전회화 중심의 교수법으로 설계
          </dt>
          <dd class="only_pc">
            학습자 중심의 참여적 발화훈련과 데이터 분석기반<br />
            맟춤 피드백은 학습자의 문장구성과 발음 유창성 증진에 있어<br />
            인지행동치료(CBT)의 효과 제공
            <div class="thum">
              <img src="@/assets/img/point_thum.png" class="inherit" alt="" />
              <p>
                학습자 발화 표현을 복수의
                <span>권장 문장과 유사도 비교 분석</span>수치화 하여 회화 실력
                진단
              </p>
            </div>
          </dd>
          <dd class="only_m">
            학습자 중심의 참여적 발화훈련과<br />데이터 분석기반 맟춤 피드백은
            학습자의<br />문장구성과 발음 유창성 증진에 있어<br />
            인지행동치료(CBT)의 효과 제공
            <div class="thum">
              <img
                src="@/assets/img/point_thum.png"
                alt=""
                class="only_pc inherit"
              />
              <img
                src="@/assets/img/m/point_thum.png"
                alt=""
                class="only_m inherit"
              />
              <p>
                학습자 발화 표현을 복수의
                <span>권장 문장과 유사도 비교 분석</span>수치화 하여 회화 실력
                진단
              </p>
            </div>
          </dd>

          <dt>
            <span class="label">Point 02</span>
            <span class="m_enter2">한 눈에 보이는 학습현황 및</span> 매일
            업데이트 되는<br />유익한 컨텐츠로 영어 실력 UP!
          </dt>

          <dd class="last">
            <img
              src="@/assets/img/point_thum2.png"
              alt=""
              class="only_pc inherit"
            />
            <img
              src="@/assets/img/m/point_thum2.png"
              alt=""
              class="only_m inherit"
            />
            <div class="thum">
              <ul>
                <li>
                  발음 클리닉
                  <img
                    src="@/assets/img/point_thum2_1.png"
                    alt=""
                    class="only_pc inherit"
                  />
                  <img
                    src="@/assets/img/m/point_thum2_1.png"
                    alt=""
                    class="only_m inherit"
                  />
                </li>
                <li>
                  Daily Writing
                  <img
                    src="@/assets/img/point_thum2_2.png"
                    alt=""
                    class="only_pc inherit"
                  />
                  <img
                    src="@/assets/img/m/point_thum2_2.png"
                    alt=""
                    class="only_m inherit"
                  />
                </li>
                <li>
                  99초 영어회화
                  <img
                    src="@/assets/img/point_thum2_3.png"
                    alt=""
                    class="only_pc inherit"
                  />
                  <img
                    src="@/assets/img/m/point_thum2_3.png"
                    alt=""
                    class="only_m inherit"
                  />
                </li>
              </ul>
            </div>
          </dd>
        </dl>
      </div>

      <div class="ai_video">
        <h2>
          AI튜터가 궁금하다면
          <strong>영상을 클릭해보세요</strong>
        </h2>

        <div class="youtube">
          <iframe
            src="https://www.youtube.com/embed/vSUUv1KVmhk"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
        <p>
          동영상이 보이지 않는 분은
          <a
            class="pointer"
            @click="newPage('https://www.youtube.com/watch?v=vSUUv1KVmhk')"
            >여기</a
          >를 클릭해 주세요.
        </p>
      </div>

      <div class="ai_check">
        <span class="label">HRD Check Point</span>
        <p class="only_pc">
          잠깐! 이렇게 좋은 AI튜터!
          <strong>우리 회사에 <span>딱!</span> 맞는 학습은 없을까?</strong>
        </p>
        <p class="only_m">
          잠깐! 이렇게 좋은 AI튜터!
          <strong>우리 회사에 <span>딱!</span> 맞는<br />학습은 없을까?</strong>
        </p>
        <div class="chatting">
          <div class="left_chat clearfix">
            <div class="profile profile1"></div>
            <div class="bubble">
              <span>Q.</span> 우리
              <strong>회사 업무 특성에 딱 맞는 미션</strong>들로 구성할 수
              없을까요?
            </div>
          </div>
          <div class="right_chat clearfix">
            <div class="bubble">
              <span>A.</span> 맞춤 미션 개발로 우리 회사에 딱! 맞는,
              <strong>현업 적용도 높은 AI튜터 학습</strong>이 가능해요~
            </div>
            <div class="profile profile2"></div>
          </div>
        </div>
      </div>

      <div class="ai_class">
        <div>
          <h2>S건설 건설영어과정</h2>
          <p class="only_pc">
            계약에서 시공, 현장관리까지!<br />
            현업에서 자주 쓰이는<br />
            건설영어 컨텐츠 맞춤 개발
          </p>
          <p class="only_m">
            계약에서 시공, 현장관리까지!<br />
            현업에서 자주 쓰이는 건설영어 컨텐츠 맞춤 개발
          </p>

          <div class="slider" v-if="slickShow">
            <VueSlickCarousel v-bind="slickOptions">
              <div class="slider-item">
                <img
                  class="slider-img"
                  src="@/assets/img/aitutor_img_08.png"
                  alt=""
                />
              </div>
              <div class="slider-item">
                <img
                  class="slider-img"
                  src="@/assets/img/aitutor_img_09.png"
                  alt=""
                />
              </div>
              <div class="slider-item">
                <img
                  class="slider-img"
                  src="@/assets/img/aitutor_img_10.png"
                  alt=""
                />
              </div>
            </VueSlickCarousel>
          </div>
        </div>
        <div class="m-ai">
          <h2>A항공사 캐빈 크루 영어과정</h2>
          <p class="only_pc">
            항공 승무원의 다양한<br />
            기내 상황 별<br />
            승객응대 컨텐츠 맞춤 개발
          </p>
          <p class="only_m">
            항공 승무원의 다양한<br />
            기내 상황 별 승객응대 컨텐츠 맞춤 개발
          </p>

          <div class="slider" v-if="slickShow">
            <VueSlickCarousel v-bind="slickOptions">
              <div class="slider-item">
                <img
                  class="slider-img"
                  src="@/assets/img/aitutor_img_11.png"
                  alt=""
                />
              </div>
              <div class="slider-item">
                <img
                  class="slider-img"
                  src="@/assets/img/aitutor_img_12.png"
                  alt=""
                />
              </div>
              <div class="slider-item">
                <img
                  class="slider-img"
                  src="@/assets/img/aitutor_img_13.png"
                  alt=""
                />
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </div>

      <div class="tech_qa">
        <div class="inner">
          <h2 class="pt-100px" id="aitutorInquiry">문의하기</h2>
          <p>
            B2B 교육 및 솔루션에 대한 문의를 남겨주시면 담당자가 확인 후
            <span class="pc_enter"
              >최대한 빠른 시간 내에 연락드리겠습니다.</span
            >
            <strong
              >(혹시 이미 교육을 받고 계신 학습자이신가요?
              <a
                class="pointer"
                @click="
                  newPage('http://carrotenglish.kr/phone/main_new/contact')
                "
                >Click!</a
              >)</strong
            >
          </p>

          <div class="qa_table">
            <div>
              <h3>회사명</h3>
              <input
                type="text"
                class="qa-input"
                v-model="inquiryData.company"
              />
            </div>
            <div>
              <h3>담당자명</h3>
              <input
                type="text"
                class="qa-input"
                v-model="inquiryData.manager"
              />
            </div>
            <div>
              <h3>연락처</h3>
              <input type="text" class="qa-input" v-model="inquiryData.phone" />
            </div>
            <div>
              <h3>이메일</h3>
              <input type="text" class="qa-input" v-model="inquiryData.email" />
            </div>
            <div>
              <h3>유입경로</h3>
              <ul class="funnel-list">
                <li>
                  <input
                    type="radio"
                    name="path"
                    id="path1"
                    value="path1"
                    v-model="selectEnterPath"
                  />
                  <label for="path1" class="pointer">캐럿 담당자 미팅</label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="path"
                    id="path2"
                    value="path2"
                    v-model="selectEnterPath"
                  />
                  <label for="path2" class="pointer"
                    >캐럿 컨퍼런스 및 설명회 등 모임</label
                  >
                </li>
                <li>
                  <input
                    type="radio"
                    name="path"
                    id="path3"
                    value="path3"
                    v-model="selectEnterPath"
                  />
                  <label for="path3" class="pointer"
                    >온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브,
                    블로그 등)</label
                  >
                </li>
                <li>
                  <input
                    type="radio"
                    name="path"
                    id="path4"
                    value="path4"
                    v-model="selectEnterPath"
                  />
                  <label for="path4" class="pointer">인터넷 검색</label>
                </li>
                <li>
                  <input
                    type="radio"
                    name="path"
                    id="path5"
                    value="path5"
                    v-model="selectEnterPath"
                  />
                  <label for="path5" class="pointer"
                    >캐럿글로벌 종합안내서 책자 및 사보 등 자료</label
                  >
                </li>
                <li>
                  <input
                    type="radio"
                    name="path"
                    id="path6"
                    value="path6"
                    v-model="selectEnterPath"
                  />
                  <label for="path6" class="pointer"
                    >타사 담당자 및 전임자 등 지인 소개</label
                  >
                </li>
                <li class="etc">
                  <input
                    type="radio"
                    name="path"
                    id="path7"
                    value="path7"
                    v-model="selectEnterPath"
                  />
                  <label for="path7" class="pointer">기타</label>
                  <input
                    v-show="selectEnterPath === 'path7'"
                    type="text"
                    name="enterPathText"
                    id="enterPathText"
                    class="etc-input"
                    placeholder="직접 입력"
                    v-model="selectEnterPathText"
                  />
                </li>
              </ul>
            </div>
            <div class="qa_cont">
              <h3>문의사항</h3>
              <textarea
                class="textarea"
                placeholder="온라인·AI교육과정 문의합니다."
                v-model="inquiryData.contents"
              ></textarea>
            </div>
            <div class="qa_agree">
              <p>
                <input
                  type="checkbox"
                  id="agree_check"
                  v-model="inquiryData.agree"
                />
                <label for="agree_check" class="check_label"
                  >개인정보 수집 및 이용에 동의합니다.</label
                >
              </p>
              <button class="pointer" @click="saveInquiry()">확인</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer></Footer>
  </div>
</template>

<script>
import Header from "@/components/Solutions/Header.vue";
import Footer from "@/components/Solutions/Footer.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
// optional style for arrows & dots
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
export default {
  components: { Header, Footer, VueSlickCarousel },
  data() {
    return {
      slickShow: false,
      slickOptions: {
        dots: true,
        arrows: false,
        edgeFriction: 0.35,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      inquiryData: {
        category: "INBOUND",
        company: "", //고객사명
        manager: "", //담당자
        phone: "", //연락처
        email: "", //이메일
        contents: "", //내용
        agree: false,
        enterPath: "", //유입경로
        enterPathText: "",
        enterUrl: window.location.href, //사이트주소
      },
      selectEnterPath: "",
      selectEnterPathText: "",
      pathValue: [
        { key: "path1", value: "캐럿 담당자 미팅" },
        { key: "path2", value: "캐럿 컨퍼런스 및 설명회 등 모임" },
        {
          key: "path3",
          value:
            "온라인 홍보 (HR캐스터, 이메일 홍보, 인스타그램, 유튜브, 블로그 등)",
        },
        { key: "path4", value: "인터넷 검색" },
        { key: "path5", value: "캐럿글로벌 종합안내서 책자 및 사보 등 자료" },
        { key: "path6", value: "타사 담당자 및 전임자 등 지인 소개" },
        { key: "path7", value: "기타" },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.slickShow = true;
    });
  },
  methods: {
    newPage(path) {
      window.open(path, "_blank");
    },
    saveInquiry() {
      let flag = false;
      for (const key in this.inquiryData) {
        if (key === "company" && !this.inquiryData[key]) {
          alert("회사명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "manager" && !this.inquiryData[key]) {
          alert("담당자명을 입력해주세요");
          flag = true;
          return;
        } else if (key === "phone" && !this.inquiryData[key]) {
          alert("연락처를 입력해주세요");
          flag = true;
          return;
        } else if (key === "email" && !this.inquiryData[key]) {
          alert("이메일을 입력해주세요");
          flag = true;
          return;
        } else if (key === "contents" && !this.inquiryData[key]) {
          alert("내용을 입력해주세요");
          flag = true;
          return;
        } else if (key === "agree" && !this.inquiryData[key]) {
          alert("개인정보 수집에 동의해주세요");
          flag = true;
          return;
        }
      }

      if (
        !this.inquiryData["enterPath"] &&
        !this.inquiryData["enterPathText"]
      ) {
        alert("유입경로를 선택 및 기타에 입력해주세요");
        flag = true;
        return false;
      }

      if (!flag) {
        const find = this.pathValue.find(
          (findItem) => findItem["key"] === this.inquiryData["enterPath"]
        );
        const pathText = find ? find["value"] : "";
        this.inquiryData["enterPath"] = pathText;

        this.axios
          .get("/rest/external/addSMP", { params: this.inquiryData })
          .then((res) => {
            if (res.data.err === 0) {
              alert("문의가 완료되었습니다.");
              this.inquiryData = {
                category: "INBOUND",
                company: "", //고객사명
                manager: "", //담당자
                phone: "", //연락처
                email: "", //이메일
                contents: "", //내용
                agree: false,
                enterPath: "",
                enterPathText: "",
                enterUrl: window.location.href, //사이트주소
              };
            } else {
              alert(res.data.err_msg);
            }
          })
          .catch((err) => {
            console.error("err : ", err);
            alert("문의하기에 실패하였습니다.");
          });
      }
    },
  },

  watch: {
    selectEnterPath: function (val) {
      if (val === "path7") {
        this.inquiryData.enterPath = "";
      } else {
        this.inquiryData.enterPath = val;
        this.inquiryData.enterPathText = "";
        this.selectEnterPathText = "";
      }
    },

    selectEnterPathText: function (val) {
      this.inquiryData.enterPathText = val;
    },
  },
};
</script>

<style lang="scss" scoped>
#aitutor {
  .banner.ai_tutor {
    height: 780px;
    background-image: url("~@/assets/img/ai_tutor_banner.png");
  }
  .banner.ai_tutor p {
    padding-top: 150px;
    font-size: 40px;
    letter-spacing: -1px;
    color: #fff;
    line-height: 1.669;
    font-weight: 500;
  }

  .banner.ai_tutor p span {
    color: #21156a;
    font-weight: 500;
  }

  .banner.ai_tutor h2 {
    padding-top: 26px;
    padding-bottom: 58px;
    font-size: 106px;
    font-weight: bold;
    color: #fff;
    letter-spacing: -1px;
  }

  .banner.ai_tutor h2 img {
    display: inline-block;
    vertical-align: middle;
    margin: -20px 0 0 -20px;
  }

  .banner.ai_tutor h2 img.only_m {
    display: none;
  }

  .banner.ai_tutor a {
    display: inline-block;
    width: 283px;
    height: 75px;
    line-height: 73px;
    text-align: center;
    border-radius: 38px;
    color: #fff;
    font-size: 26px;
    font-weight: bold;
    background-color: #26c3e2;
    box-sizing: border-box;
    box-shadow: 4.944px 15.217px 24px 0px rgba(94, 77, 235, 0.19);
  }

  .ai_step {
    padding: 117px 0 100px;
    text-align: center;
    box-sizing: border-box;
  }

  .ai_step h2 {
    font-size: 50px;
    font-weight: bold;
    letter-spacing: -1px;
    color: #000;
  }

  .ai_step h2 span {
    display: block;
    padding-bottom: 11px;
    font-size: 40px;
    letter-spacing: -1px;
    font-weight: 400;
  }

  .ai_step h2 strong {
    background: linear-gradient(to right, #584deb, #26c3e2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .step_box {
    padding-top: 66px;
  }

  .label_list {
    position: relative;
    width: 1200px;
    margin: auto;
    text-align: center;
    font-size: 0;
  }

  .label_list::before {
    content: "";
    position: absolute;
    left: 0;
    top: 19px;
    width: 100%;
    height: 1px;
    background-color: #26c3e2;
    z-index: -1;
  }

  .label_list li {
    display: inline-block;
    vertical-align: middle;
    width: 20%;
  }

  .label_list li.point {
    width: 40%;
  }

  .label_list span {
    display: block;
    width: 83px;
    height: 39px;
    margin: auto;
    line-height: 37px;
    border-radius: 19.5px;
    font-size: 20px;
    font-weight: 500;
    color: #fff;
    letter-spacing: -1px;
    background-color: #26c3e2;
    box-sizing: border-box;
  }

  .label_list li.last span {
    margin-right: 62px;
  }

  .step_list {
    text-align: center;
    font-size: 0;
    box-sizing: border-box;
    padding-right: 4px;
  }

  .step_list li {
    display: inline-block;
    vertical-align: top;
    width: 222px;
  }

  .step_list li:first-child {
    margin-right: 6px;
  }

  .step_list li + li {
    margin-left: 22px;
  }

  .step_list li img {
    max-width: none;
  }

  .step_list span {
    display: block;
    padding: 22px 0 10px;
    font-size: 20px;
    letter-spacing: -1px;
    color: #000;
  }

  .step_list .desc {
    position: relative;
    padding-top: 31px;
    z-index: 1;
  }

  .step_list h3 {
    padding-bottom: 12px;
    font-size: 24px;
    font-weight: bold;
    color: #000;
    letter-spacing: -1px;
  }

  .step_list p {
    white-space: nowrap;
    font-size: 18px;
    letter-spacing: -1px;
    color: #626262;
    line-height: 1.52;
  }

  .step_list li.point p {
    width: 255px;
    transform: translateX(-14px);
  }

  .ai_about {
    padding: 97px 0 102px;
    text-align: center;
    box-sizing: border-box;
    background-color: #f2f6fc;
  }

  .ai_about h2 {
    position: relative;
    display: inline-block;
    font-size: 50px;
    font-weight: bold;
    color: #000;
    letter-spacing: -1px;
  }

  .ai_about h2::before,
  .ai_about h2::after {
    content: "";
    position: absolute;
    top: 10px;
    width: 25px;
    height: 21px;
  }

  .ai_about h2::before {
    left: -58px;
    background: url("~@/assets/img/quotes3.png") center no-repeat;
  }

  .ai_about h2::after {
    right: -58px;
    background: url("~@/assets/img/quotes4.png") center no-repeat;
  }

  .ai_about h2 span {
    font-weight: bold;
    background: linear-gradient(to right, #584deb, #26c3e2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .ai_about p {
    padding-top: 32px;
    font-size: 30px;
    letter-spacing: -1px;
    color: #626262;
    line-height: 1.512;
  }

  .bubble_wrap {
    width: 1200px;
    margin: auto;
  }

  .bubble_list {
    position: relative;
    margin-top: 103px;
    padding: 0 12px 115px;
  }

  .bubble_list::before {
    content: "";
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 44px;
    width: 11px;
    height: 64px;
    background: url("~@/assets/img/step_round.png") center no-repeat;
  }

  .bubble_list li {
    width: 733px;
    height: 202px;
    font-size: 40px;
    line-height: 132px;
    font-weight: 500;
    padding-left: 105px;
    text-align: left;
    letter-spacing: -1px;
    color: #000;
    background: url("~@/assets/img/bubble.png") 0 0 no-repeat;
    background-size: 100%;
    box-sizing: border-box;
  }

  .bubble_list li.bubble1 {
    position: relative;
    z-index: 1;
  }

  .bubble_list li.bubble2 {
    position: absolute;
    right: -36px;
    top: 105px;
    width: 694px;
    height: 210px;
    padding-left: 130px;
    line-height: 122px;
  }

  .bubble_list li.bubble3 {
    margin-top: 122px;
    margin-left: 85px;
    padding-left: 150px;
  }

  .bubble_wrap h3 {
    padding-bottom: 77px;
    font-size: 30px;
    letter-spacing: -1px;
    color: #626262;
  }

  .bubble_wrap h3 strong {
    font-size: 40px;
    font-weight: bold;
    color: #000;
  }

  .ai_keyword {
    padding: 92px 0 82px;
    text-align: center;
    background: linear-gradient(90deg, rgb(8, 40, 48) 0%, rgb(33, 33, 33) 100%);
  }

  .ai_keyword h2 {
    font-size: 50px;
    font-weight: bold;
    color: #fff;
    letter-spacing: -1px;
  }

  .ai_keyword h2 span {
    font-weight: bold;
    background: linear-gradient(to right, #584deb, #26c3e2);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  .ai_point1 {
    padding-top: 9px;
  }

  .ai_point1 dt {
    padding-top: 104px;
    font-size: 37px;
    color: #fff;
    line-height: 1.6;
    letter-spacing: -1px;
  }

  .ai_point1 dt .label {
    display: block;
    width: 284px;
    height: 88px;
    font-weight: bold;
    margin: 0 auto 32px;
    line-height: 86px;
    border-radius: 44px;
    font-size: 40px;
    letter-spacing: -1px;
    color: #fff;
    background-image: linear-gradient(
      128deg,
      rgb(88, 77, 235),
      rgb(38, 195, 226)
    );
    box-sizing: border-box;
  }

  .ai_point1 dd {
    padding-top: 51px;
    padding-bottom: 24px;
    font-size: 30px;
    color: #898989;
    letter-spacing: -1px;
    line-height: 1.512;
  }

  .ai_point1 .thum {
    width: 1200px;
    margin: 65px auto 0;
    padding: 66px 0 76px;
    // background-image: linear-gradient(127deg, rgb(225,225,225) 0%, rgb(255,255,255) 100%);
    background-image: -webkit-linear-gradient(
      127deg,
      rgb(225, 225, 225) 0%,
      rgb(255, 255, 255) 100%
    );
    box-shadow: 0px 1px 87px 0px rgba(0, 0, 0, 0.09);
    border-radius: 34px;
    box-sizing: border-box;
  }

  .ai_point1 .thum p {
    margin-top: -30px;
    padding: 0 175px;
    font-size: 35px;
    letter-spacing: -1.3px;
    color: #000;
  }

  .ai_point1 .thum p span {
    font-size: 40px;
    font-weight: 500;
    color: #584deb;
    letter-spacing: -1.3px;
  }

  .ai_point1 ul {
    padding-top: 12px;
    font-size: 0;
  }

  .ai_point1 li {
    display: inline-block;
    vertical-align: middle;
    font-size: 28px;
    font-weight: 500;
    text-indent: -7px;
    color: #000;
    letter-spacing: -1px;
  }

  .ai_point1 li + li {
    padding-left: 51px;
  }

  .ai_point1 li img {
    display: block;
    margin: auto;
    padding-top: 18px;
  }

  .ai_point1 dd.last {
    padding-top: 102px;
  }

  .ai_point1 dd.last .thum {
    margin-top: 81px;
    padding-bottom: 56px;
  }

  .ai_video {
    padding: 98px 0;
    text-align: center;
  }

  .ai_video h2 {
    font-size: 40px;
    letter-spacing: -1.3px;
    color: #000;
  }

  .ai_video h2 strong {
    display: block;
    padding-top: 17px;
    font-size: 50px;
    letter-spacing: -1.3px;
    color: #000;
  }

  .youtube {
    width: 1200px;
    height: 868px;
    margin: 46px auto 0;
    padding: 40px;
    background: url("~@/assets/img/ipad.png") center no-repeat;
    border-radius: 62px;
    box-sizing: border-box;
    box-shadow: 31.547px 45.053px 87px 0px rgba(0, 0, 0, 0.2);
  }

  .youtube iframe {
    width: 100%;
    height: 100%;
    border-radius: 30px;
  }

  .ai_video p {
    padding-top: 62px;
    font-size: 32px;
    color: #626262;
    letter-spacing: -1.3px;
  }

  .ai_video p a {
    font-weight: 500;
    color: #584deb;
  }

  .ai_check {
    width: 100%;
    height: 877px;
    padding: 100px 0;
    text-align: center;
    background: url("~@/assets/img/ai_check_bg.png") center no-repeat;
    box-sizing: border-box;
  }

  .ai_check .label {
    display: inline-block;
    padding: 0 55px;
    height: 88px;
    line-height: 86px;
    font-size: 40px;
    font-weight: bold;
    color: #0024ff;
    letter-spacing: -1px;
    border-radius: 44px;
    border: 1.5px solid #0024ff;
    box-sizing: border-box;
  }

  .ai_check p {
    padding-top: 32px;
    font-size: 40px;
    color: #fff;
    letter-spacing: -1px;
  }

  .ai_check p strong {
    display: block;
    margin-top: -12px;
    font-size: 50px;
    color: #fff;
    letter-spacing: -1px;
  }

  .ai_check p span {
    font-size: 66.2px;
    color: #fff;
    font-weight: bold;
    letter-spacing: -1px;
  }

  .chatting {
    width: 1210px;
    margin: auto;
    padding-top: 41px;
    box-sizing: border-box;
  }

  .chatting .profile {
    position: absolute;
    top: 0;
    width: 154px;
    height: 154px;
    border-radius: 50%;
  }

  .bubble {
    width: 693px;
    height: 209px;
    font-size: 32px;
    letter-spacing: -1px;
    color: #010000;
    line-height: 1.552;
    box-sizing: border-box;
  }

  .bubble span {
    font-weight: bold;
    font-size: 32px;
    letter-spacing: -1px;
  }

  .left_chat {
    position: relative;
    padding-left: 175px;
    text-align: left;
  }

  .left_chat .profile {
    left: 3px;
    top: 8px;
  }

  .left_chat .bubble {
    float: left;
    padding: 33px 52px 0 64px;
    background: url("~@/assets/img/bubble2.png") 0 0 no-repeat;
  }

  .left_chat .bubble span {
    color: #584deb;
  }

  .right_chat {
    position: relative;
    transform: translateY(-4px);
    padding-right: 143px;
    text-align: left;
  }

  .right_chat .profile {
    right: 2px;
    top: 14px;
  }

  .right_chat .bubble {
    float: right;
    padding: 33px 77px 0 52px;
    background: url("~@/assets/img/bubble3.png") 0 0 no-repeat;
  }

  .right_chat .bubble span {
    color: #26c3e2;
  }

  .profile1 {
    background-image: url("~@/assets/img/profile1.png");
  }

  .profile2 {
    background-image: url("~@/assets/img/profile2.png");
  }

  .ai_class {
    padding: 82px 0 82px 0;
    font-size: 0;
    text-align: center;
    min-height: 1230px;
  }

  .ai_class > div {
    display: inline-block;
    vertical-align: middle;
    // filter : drop-shadow(18px 19px 17px rgba(0,0,0,0.31))
  }

  .ai_class > div + div {
    margin-left: 152px;
  }

  .ai_class h2 {
    font-size: 32px;
    color: #000;
    font-weight: bold;
    letter-spacing: -1.3px;
  }

  .ai_class p {
    padding: 32px 0 30px;
    font-size: 28px;
    color: #626262;
    letter-spacing: -1.3px;
  }

  .ai_class .pagination {
    padding-bottom: 17px;
    font-size: 0;
    text-align: center;
  }

  .ai_class .pagination span {
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    margin: 0 12px;
    border-radius: 50%;
    background-color: #a8e7f3;
  }

  .ai_class .pagination span.on {
    background-color: #26c3e2;
  }

  .tech_qa {
    background-color: #f5f5f5;
  }

  .tech_qa .inner {
    padding-top: 0px !important;
  }

  .tech_qa p strong a {
    color: #26c3e2;
  }

  .textarea {
    width: 100%;
    height: 250px;
    padding: 17px 22px;
    border: 1px solid #252525;
    border-radius: 8px;
    font-size: 20px;
    letter-spacing: -1px;
    box-sizing: border-box;
  }

  .qa_table div.qa_agree {
    position: absolute;
    right: 0;
    bottom: 0;
    padding: 0;
    width: 555px;
  }

  .qa_agree button {
    border-color: #26c3e2;
    color: #26c3e2;
  }

  .only_m {
    display: none !important;
  }

  .funnel-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    li {
      display: flex;
      align-items: center;
      gap: 0 5px;

      label {
        font-size: 13px;
        color: #000000;
      }

      input[type="radio"] {
        width: auto;
        margin-bottom: 0;
      }

      input[type="text"] {
        width: auto;
        font-size: 13px;
        color: #ffffff;
        margin-bottom: 0;
      }

      &.etc {
        width: 100%;

        .etc-input {
          color: #000000;
          border-radius: 4px;
          border: 1px solid #252525;
        }
      }
    }
  }

  img {
    border-width: 0;
    height: auto;
    max-width: 100%;
  }

  @media screen and (max-width: 1200px) {
    .banner.ai_tutor {
      height: auto;
      padding-bottom: 80px;
      background-image: url("~@/assets/img/m/ai_tutor_banner.png");
    }

    .banner.ai_tutor p {
      padding-top: 59px;
      font-size: 18.5px;
    }

    .banner.ai_tutor p strong {
      display: block;
      font-weight: 500;
      line-height: 1.3;
      font-size: 21px;
    }

    .banner.ai_tutor h2 {
      padding-bottom: 47px;
      padding-top: 16px;
      font-size: 43px;
    }

    .banner.ai_tutor h2 img.only_m {
      display: inline-block !important;
      width: 147.5px;
      margin: -15px 0 0 -5px;
    }

    .banner.ai_tutor a {
      display: inline-block;
      width: 141.5px;
      height: 37.5px;
      line-height: 36px;
      border-radius: 19px;
      font-size: 13px;
      box-shadow: 4.944px 15.217px 24px 0px rgba(94, 77, 235, 0.19);
    }

    .ai_step {
      padding: 48.5px 0 41px;
    }

    .ai_step h2 {
      font-size: 25px;
    }

    .ai_step h2 span {
      padding-bottom: 8px;
      font-size: 20px;
    }

    .step_box {
      padding-top: 33px;
    }

    .step_box > div {
      width: 100%;
    }

    .ai_about {
      padding: 42px 0 47px;
    }

    .ai_about h2 {
      font-size: 25px;
    }

    .ai_about h2::before,
    .ai_about h2::after {
      content: "";
      position: absolute;
      top: 5px;
      width: 12.5px;
      height: 10px;
      background-size: 100% !important;
    }

    .ai_about h2::before {
      left: -29px;
    }

    .ai_about h2::after {
      right: -29px;
    }

    .ai_about h2 span {
      display: block;
    }

    .ai_about p {
      padding-top: 10px;
      font-size: 15px;
    }

    .bubble_wrap {
      width: 100%;
      max-width: 335px;
    }

    .bubble_list {
      margin-top: 36px;
      padding: 0 0 61.5px;
    }

    .bubble_list li,
    .bubble_list li.bubble2,
    .bubble_list li.bubble3 {
      width: 216px;
      height: 66px;
      font-size: 12px;
      line-height: 37px;
      padding-left: 26px;
      background: url("~@/assets/img/m/bubble.png") 0 0 no-repeat;
      background-size: 100%;
      box-sizing: border-box;
    }

    .bubble_list li.bubble2 {
      right: -20px;
      top: 28.5px;
      width: 205px;
      height: 66px;
    }

    .bubble_list li.bubble3 {
      margin-top: 25px;
      margin-left: 23px;
      padding-left: 37.5px;
    }

    .bubble_list::before {
      bottom: 21px;
      width: 5.5px;
      height: 32px;
      background: url("~@/assets/img/m/step_round.png") center no-repeat;
      background-size: 100%;
    }

    .bubble_wrap h3 {
      padding-bottom: 32px;
      font-size: 15px;
    }

    .bubble_wrap h3 strong {
      font-size: 20px;
    }

    .ai_keyword {
      padding: 42px 20px 38px;
    }

    .ai_keyword h2 {
      font-size: 25px;
    }

    .ai_point1 {
      padding-top: 3px;
    }

    .ai_point1 dt {
      padding-top: 35px;
      font-size: 18.5px;
      line-height: 1.4;
    }

    .ai_point1 dt .label {
      width: 142px;
      height: 44px;
      margin: 0 auto 15px;
      line-height: 42px;
      border-radius: 22px;
      font-size: 20px;
    }

    .ai_point1 dd {
      padding-top: 25px;
      padding-bottom: 8px;
      font-size: 15px;
    }

    .ai_point1 .thum {
      width: 100%;
      margin: 32.5px auto 0;
      padding: 25px 39px 26px;
      border-radius: 10px;
    }

    .ai_point1 .thum img {
      margin: auto;
    }

    .ai_point1 .thum p {
      margin-top: 11px;
      padding: 0;
      font-size: 17.5px;
    }

    .ai_point1 .thum p span {
      display: block;
      font-size: 20px;
    }

    .ai_point1 dd.last {
      padding-top: 35px;
    }

    .ai_point1 dd.last > img {
      width: 100%;
      box-sizing: border-box;
    }

    .ai_point1 dd.last .thum {
      margin-top: 27px;
      padding-top: 21px;
      padding: 21px 60px 12px;
    }

    .ai_point1 ul {
      padding-top: 0;
      font-size: 0;
    }

    .ai_point1 li {
      display: block;
      font-size: 3.91645vw;
      text-indent: -7px;
    }

    .ai_point1 li + li {
      padding-left: 0;
      padding-top: 14px;
    }

    .ai_point1 li img {
      display: block;
      margin: auto;
      width: 100%;
      padding-top: 5px;
    }

    .ai_video {
      padding: 41px 20px;
    }

    .ai_video h2 {
      font-size: 20px;
      letter-spacing: -1px;
    }

    .ai_video h2 strong {
      padding-top: 7px;
      font-size: 25px;
      letter-spacing: -1px;
    }

    .youtube {
      width: 335.5px;
      max-width: 335.5px;
      height: 242px;
      margin: 19px auto 0;
      padding: 11px;
      background: url("~@/assets/img/m/ipad.png") center no-repeat;
      background-size: 100%;
      border-radius: 18px;
    }

    .youtube iframe {
      width: 100%;
      height: 100%;
      border-radius: 5px;
    }

    .ai_video p {
      padding-top: 35px;
      font-size: 16px;
      letter-spacing: -1px;
    }

    .ai_check {
      height: auto;
      padding: 46.5px 0 25px;
      background: url("~@/assets/img/m/ai_check_bg.png") center no-repeat;
      background-size: cover;
    }

    .ai_check .label {
      padding: 0 30px;
      height: 44px;
      line-height: 42px;
      font-size: 20px;
      border-radius: 22px;
    }

    .ai_check p {
      padding-top: 16px;
      font-size: 20px;
    }

    .ai_check p strong {
      display: block;
      margin-top: -2px;
      font-size: 25px;
      line-height: 1.332;
      text-shadow: 5.905px 6.792px 29px rgba(47, 42, 175, 0.2);
    }

    .ai_check p span {
      font-size: 33.1px;
    }

    .chatting {
      width: 100%;
      max-width: 375px;
      margin: auto;
      padding: 18px 20px 0;
    }

    .chatting .profile {
      display: none;
    }

    .bubble {
      width: 350px;
      height: 104.5px;
      font-size: 16px;
      background-size: 100% !important;
    }

    .bubble span {
      font-size: 16px;
    }

    .left_chat {
      padding-left: 0;
    }

    .left_chat .bubble {
      padding: 15px 44px 0 31px;
    }

    .right_chat {
      position: relative;
      transform: translateY(2px);
      padding-right: 0;
    }

    .right_chat .bubble {
      margin-right: -18px;
      padding: 14px 56px 0 26px;
    }

    .ai_class {
      padding: 44px 0 48px;
      font-size: 0;
      text-align: center;
    }

    .ai_class > div {
      display: block;
    }

    .ai_class > div + div {
      margin-left: 0;
      margin-top: 55px;
    }

    .ai_class h2 {
      font-size: 17px;
      letter-spacing: -1px;
    }

    .ai_class p {
      padding: 14px 0 26px;
      font-size: 14px;
      letter-spacing: -1px;
    }

    .ai_class .pagination {
      padding-bottom: 11px;
    }

    .ai_class .pagination span {
      width: 8px;
      height: 8px;
      margin: 0 6px;
    }

    .slider img {
      width: 256px;
    }

    .tech_qa .inner {
      padding-top: 23px;
      padding-bottom: 100px;
    }

    .qa_table div.qa_agree {
      bottom: -45px;
    }

    .only_pc {
      display: none !important;
    }
    .only_m {
      display: block !important;
    }
  }

  @media screen and (max-width: 340px) {
    .youtube {
      width: 290px;
      background-size: 100% 100%;
    }

    .chatting {
      overflow: hidden;
    }

    .right_chat .bubble {
      margin-right: -35px;
    }

    .bubble_list {
      overflow: hidden;
    }

    .ai_point1 li {
      display: block;
      font-size: 15px;
      text-indent: -7px;
    }

    .step_box {
      padding-top: 33px;
    }
  }
}
</style>

<style lang="scss">
.slider {
  width: 500px;
  margin-top: 40px;
}

.slider-img {
  margin: auto;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.slick-list {
  filter: drop-shadow(18px 19px 17px rgba(0, 0, 0, 0.31));
}

.slick-dots {
  position: absolute;
  bottom: 815px;
  display: block;
  width: 100%;
  padding: 0;
  margin: 0;
  list-style: none;
  text-align: center;

  li {
    width: 16px;
    height: 16px;
    background-color: #a8e7f3;
    margin: 0 12px;
    border-radius: 50%;

    button::before {
      font-size: 0;
      color: transparent;
    }

    &.slick-active {
      background-color: #26c3e2;
    }
  }
}

@media screen and (max-width: 1200px) {
  .ai_class {
    div + div {
      margin-top: 10px;
    }
  }
  .slider {
    width: 200px;
    margin: auto;
  }

  .slick-dots {
    bottom: 400px;

    li {
      width: 8px;
      height: 8px;
      margin: 0 6px;
    }
  }
}
</style>
